"use client";

import { useState } from "react";
import dynamic from "next/dynamic";
import Slider from "./components/BannerSlider/Slider";

const TopSellers = dynamic(() => import("./components/TopSellers/TopSellers"));
const TrustBanner = dynamic(() => import("./components/TrustBanner/TrustBanner"));
const News = dynamic(() => import("./components/News/News"));
const ProductSlider = dynamic(() => import("./components/ProductSlider/ProductSlider"));
const Services = dynamic(() => import("./components/Services/Services"));

export default function Home() {
  const [isTopSellersBlack, setIsTopSellersBlack] = useState(false);

  return (
    <main className={`transition-colors duration-[1200ms] ease-in-out ${isTopSellersBlack ? "bg-[#050505]" : "bg-white"}`}>
      {/* Hero Section */}
      <section id="slider">
        <Slider />
      </section>

      {/* Products */}
      <section id="products" className={`py-8 md:py-16 transition-colors duration-[1200ms] ease-in-out ${isTopSellersBlack ? "bg-[#050505]" : "bg-white"}`}>
        <ProductSlider isDark={isTopSellersBlack} />
      </section>

      {/* Top Sellers Section */}
      <TopSellers onThemeChange={setIsTopSellersBlack} />

      {/* Trust & Stats Section attached directly below TopSellers */}
      <TrustBanner />

      {/* services */}
      <section id="services" className={`transition-colors duration-[1200ms] ease-in-out ${isTopSellersBlack ? "bg-[#050505]" : "bg-white"}`}>
        <Services isDark={isTopSellersBlack} />
      </section>

      {/* Slogan */}
      <section className={`transition-colors duration-[1200ms] ease-in-out flex justify-center items-center overflow-hidden py-4 ${isTopSellersBlack ? "bg-[#050505]" : "bg-white"}`}>
        <div className="w-full max-w-[1700px] mx-auto px-6 md:px-12 lg:px-16 flex justify-center items-center" dir="ltr">
          <h2 className={`w-full flex justify-between font-anjoman-thin text-[clamp(20px,4vw,60px)] whitespace-nowrap transition-colors duration-[1200ms] ease-in-out ${isTopSellersBlack ? "text-gray-400" : "text-[#7F7F7F]"}`}>
            {"Beyond Motion".split("").map((char, index) => (
              <span key={index}>{char === " " ? "\u00A0" : char}</span>
            ))}
          </h2>
        </div>
      </section>

      {/* About */}
      <section id="about" className={`py-8 md:py-16 transition-colors duration-[1200ms] ease-in-out ${isTopSellersBlack ? "bg-[#050505]" : "bg-white"}`}>
        <News isDark={isTopSellersBlack} />
      </section>

    </main>
  );
}
